const types = {
    FETCH_PRODUCTS_BY_CATEGORY: 'FETCH_PRODUCTS_BY_CATEGORY',
    FETCH_PRODUCTS_BY_CATEGORY_SUCCESS: 'FETCH_PRODUCTS_BY_CATEGORY_SUCCESS',
    FETCH_PRODUCTS_BY_CATEGORY_FAILED: 'FETCH_PRODUCTS_BY_CATEGORY_FAILED',
    SHOW_LOADING_PRODUCTS_BY_CATEGORY: 'SHOW_LOADING_PRODUCTS_BY_CATEGORY',
    PAGE_PRODUCTS_BY_CATEGORY: 'PAGE_PRODUCTS_BY_CATEGORY',
    SORT_PRODUCTS_BY_CATEGORY: 'SORT_PRODUCTS_BY_CATEGORY',
    FILTER_PRICE_PRODUCTS_BY_CATEGORY: 'FILTER_PRICE_PRODUCTS_BY_CATEGORY',
};

export default types;